import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  IconButton,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import UnversalSpinner from '../CommonUtilites/UniversalSpinner';
import { format } from 'date-fns';
import { RemoveCircleOutline } from '@mui/icons-material';
import axiosAPIinstance from '../../config/axiosAPIinstance';

const weightOptions = ['100g', '250g', '500g', '1kg', '100ml', '250ml', '500ml', '1L', 'Enter Manually'];

const ViewUpdateItemDetails = ({ item, isEditMode, onClose, onSave }) => {

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [weights, setWeights] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [response, setResponse] = useState({});
  const [imagePreview, setImagePreview] = useState('');
  const [additionalImagePreviews, setAdditionalImagePreviews] = useState([]);
  const [imgError, setImgError] = useState(false);
  const [dynamicWeightOptions, setDynamicWeightOptions] = useState(weightOptions);
  const [openWeightModal, setOpenWeightModal] = useState(false);
  const [selectedWeightIndex, setSelectedWeightIndex] = useState(null);
  const [manualWeightValue, setManualWeightValue] = useState('');
  const [showCalculateButton, setShowCalculateButton] = useState(true);

  const [editableItem, setEditableItem] = useState({
    productName: '',
    recommend: false,
    hsCodeBarCode: '',
    brand: '',
    category: '',
    pureVeg: 0,
    warrantyInfo: '',
    returnPolicy: '',
    manufacturer: '',
    modelNumber: '',
    tags: '',
    labels: '',
    countryOfOrigin: '',
    description: '',
    image: null,
    additionalImages: [],
    purchaseDate: format(new Date(), "yyyy-MM-dd"),
    expiryDate: format(new Date(), "yyyy-MM-dd"),
  });

  useEffect(() => {
    if (item) {
      setEditableItem({
        ...item,
        purchaseDate: item.purchaseDate || format(new Date(), "yyyy-MM-dd"),
        expiryDate: item.expiryDate || format(new Date(), "yyyy-MM-dd"),
        pureVeg: item.pureVeg ? 1 : 0, // Convert boolean to number (1/0)
        recommend: item.recommend === "true" // Convert string to boolean
      });
      const productVariants = item.productVariants || [{
        weight: '',
        mrp: '',
        costPrice: '',
        sellingPriceWithGST: '',
        sellingPrice: '',
        discountPercent: '',
        gstPercent: '',
        gstPrice: '',
        skuBarCode: '',
        availableStock: '',
        minPurchaseQty: '',
        maxPurchaseQty: '',
        dimensions: '',
        availabilityStatus: true,
        returnable: true,
        color: '',
      }];
      setWeights(productVariants);

      const variantWeights = productVariants.map(v => v.weight).filter(Boolean);
      const newWeightOptions = [...weightOptions];
      variantWeights.forEach(weight => {
        if (!newWeightOptions.includes(weight)) {
          newWeightOptions.unshift(weight); // Add to beginning
        }
      });
      setDynamicWeightOptions(newWeightOptions);

      setImagePreview(item.image || '');

      // Clean up additionalImages URLs when setting initial state
      const cleanedAdditionalImages = item.additionalImages?.map(img => {
        try {
          // Remove all escape characters and quotes
          return img.replace(/^"+|"+$/g, '').replace(/\\/g, '');
        } catch (e) {
          return img; // fallback to original if cleaning fails
        }
      }) || [];

      setAdditionalImagePreviews(cleanedAdditionalImages);
    }
  }, [item]);

  const formatFloat = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? '0.00' : num.toFixed(2);
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    setEditableItem((prevItem) => ({
      ...prevItem,
      [name]: newValue,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setEditableItem(prev => ({ ...prev, image: file }));
    setImagePreview(URL.createObjectURL(file));
    setImgError(true);
  };

  // const handleAdditionalFilesChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   setEditableItem(prev => ({ ...prev, additionalImages: files }));
  //   setAdditionalImagePreviews(files.map(file => URL.createObjectURL(file)));
  //   setImgError(true);
  // };

  const handleAdditionalFilesChange = (e) => {
    const files = Array.from(e.target.files);
    const newPreviews = files.map(file => URL.createObjectURL(file));

    setEditableItem(prev => ({
      ...prev,
      additionalImages: [...(prev.additionalImages || []), ...files]
    }));
    setAdditionalImagePreviews(prev => [...prev, ...newPreviews]);
    setImgError(true);
  };

  const handleWeightChange = (index, field, value) => {
    const updatedWeights = [...weights];
    updatedWeights[index][field] = value;
    setWeights(updatedWeights);
    setShowCalculateButton(true);
  };

  // const handleCalculate = (index) => {
  //   const weight = weights[index];
  //   const mrp = parseFloat(weight.mrp) || 0;
  //   const gstPercent = parseFloat(weight.gstPercent) || 0;
  //   const sellingPriceWithGST = parseFloat(weight.sellingPriceWithGST) || 0;

  //   let basePrice = 0;
  //   let gstAmount = 0;
  //   let discount = 0;

  //   if (gstPercent > 0) {
  //     if (sellingPriceWithGST > 0) {
  //       basePrice = sellingPriceWithGST / (1 + gstPercent / 100);
  //     } else {
  //       basePrice = mrp;
  //     }
  //     gstAmount = basePrice * (gstPercent / 100);
  //     discount = ((mrp - basePrice) / mrp) * 100;
  //     weight.sellingPrice = formatFloat(basePrice);
  //     weight.gstPrice = formatFloat(gstAmount);
  //     if (!weight.sellingPriceWithGST) {
  //       weight.sellingPriceWithGST = formatFloat(basePrice + gstAmount);
  //     }
  //     weight.discountPercent = Math.round(discount);
  //   } else {
  //     basePrice = sellingPriceWithGST > 0 ? sellingPriceWithGST : mrp;
  //     weight.sellingPrice = formatFloat(basePrice);
  //     weight.gstPrice = formatFloat(0);
  //     if (!weight.sellingPriceWithGST) {
  //       weight.sellingPriceWithGST = formatFloat(basePrice);
  //     }
  //   }

  //   const updatedWeights = [...weights];
  //   updatedWeights[index] = weight;
  //   setWeights(updatedWeights);
  //   setShowCalculateButton(false);
  // };

  const handleCalculate = (index) => {
    const weight = weights[index];
    const mrp = parseFloat(weight.mrp) || 0;
    const gstPercent = parseFloat(weight.gstPercent) || 0;
    let sellingPriceWithGST = parseFloat(weight.sellingPriceWithGST) || 0;
    let basePrice = 0;
    let gstAmount = 0;
    let discount = 0;

    if (gstPercent > 0) {
      // Calculate basePrice
      if (sellingPriceWithGST > 0) {
        basePrice = sellingPriceWithGST / (1 + gstPercent / 100);
      } else {
        basePrice = mrp;
      }

      // Ensure sellingPriceWithGST is valid (between basePrice and MRP)
      const minSellingPriceWithGST = basePrice; // basePrice + GST (but GST could be 0)
      const maxSellingPriceWithGST = mrp * (1 + gstPercent / 100); // MRP + GST

      if (sellingPriceWithGST <= 0 || sellingPriceWithGST < minSellingPriceWithGST) {
        sellingPriceWithGST = minSellingPriceWithGST;
      } else if (sellingPriceWithGST > maxSellingPriceWithGST) {
        sellingPriceWithGST = maxSellingPriceWithGST;
      }

      // Recalculate basePrice if sellingPriceWithGST was adjusted
      basePrice = sellingPriceWithGST / (1 + gstPercent / 100);
      gstAmount = basePrice * (gstPercent / 100);
      discount = ((mrp - basePrice) / mrp) * 100;

      weight.sellingPrice = formatFloat(basePrice);
      weight.gstPrice = formatFloat(gstAmount);
      weight.sellingPriceWithGST = formatFloat(sellingPriceWithGST);
      weight.discountPercent = Math.round(formatFloat(discount));
    } else {
      // GST is 0%, so sellingPriceWithGST = basePrice
      basePrice = sellingPriceWithGST > 0 ? sellingPriceWithGST : mrp;

      // Ensure sellingPriceWithGST is between basePrice and MRP
      if (sellingPriceWithGST <= 0 || sellingPriceWithGST < basePrice) {
        sellingPriceWithGST = basePrice;
      } else if (sellingPriceWithGST > mrp) {
        sellingPriceWithGST = mrp;
      }

      // Reassign basePrice if sellingPriceWithGST was adjusted
      basePrice = sellingPriceWithGST;
      discount = ((mrp - basePrice) / mrp) * 100;

      weight.sellingPrice = formatFloat(basePrice);
      weight.gstPrice = formatFloat(0);
      weight.gstPercent = formatFloat(0);
      weight.sellingPriceWithGST = formatFloat(basePrice);
      weight.discountPercent = formatFloat(discount);
    }

    const updatedWeights = [...weights];
    updatedWeights[index] = weight;
    setWeights(updatedWeights);
    setShowCalculateButton(false);
  };

  const addWeightField = () => {
    setWeights([
      ...weights,
      {
        weight: '',
        mrp: '',
        costPrice: '',
        sellingPriceWithGST: '',
        sellingPrice: '',
        discountPercent: '',
        gstPercent: '',
        gstPrice: '',
        skuBarCode: '',
        availableStock: '',
        minPurchaseQty: '',
        maxPurchaseQty: '',
        dimensions: '',
        availabilityStatus: true,
        returnable: true,
        color: '',
      },
    ]);
  };

  const removeWeightField = (index) => {
    if (weights.length > 1) {
      setWeights(weights.filter((_, i) => i !== index));
    }
  };

  const handleDateChange = (name, date) => {
    const formattedDate = format(date, "yyyy-MM-dd");
    setEditableItem(prev => ({ ...prev, [name]: formattedDate }));
  };

  const handleManualWeightSubmit = () => {
    if (selectedWeightIndex !== null && manualWeightValue) {
      handleWeightChange(selectedWeightIndex, 'weight', manualWeightValue);
      if (!dynamicWeightOptions.includes(manualWeightValue)) {
        setDynamicWeightOptions([manualWeightValue, ...dynamicWeightOptions]);
      }
    }
    setManualWeightValue('');
    setOpenWeightModal(false);
  };

  const removeAdditionalImage = (index) => {
    setAdditionalImagePreviews(prev => prev.filter((_, i) => i !== index));
    setEditableItem(prev => ({
      ...prev,
      additionalImages: prev.additionalImages.filter((_, i) => i !== index)
    }));
  };

  // const handleSave = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
  //   Object.keys(editableItem).forEach((key) => {
  //     if (editableItem[key] instanceof File) {
  //       formData.append(key, editableItem[key]);
  //     } else if (Array.isArray(editableItem[key])) {
  //       editableItem[key].forEach((file) => {
  //         if (file instanceof File) {
  //           formData.append(key, file);
  //         }
  //       });
  //     } else {
  //       formData.append(key, editableItem[key]);
  //     }
  //   });

  //   formData.append('productVarients', JSON.stringify(weights));

  //   try {
  //     setLoading(true);
  //     const response = await axiosAPIinstance.patch(`/product/updateProductDetails/${item.productId}`, formData, {
  //       headers: { 'Content-Type': 'multipart/form-data' }
  //     });
  //     setResponse(response.data);
  //     setLoading(false);
  //     setOpenModal(true);
  //   } catch (error) {
  //     console.error('Error updating item:', error);
  //     setResponse({ success: false, message: 'Error updating item. Please try again.' });
  //     setLoading(false);
  //   }
  // };

  const handleSave = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Append all product fields
    formData.append('productName', editableItem.productName);
    formData.append('hsCodeBarCode', editableItem.hsCodeBarCode);
    formData.append('brand', editableItem.brand);
    formData.append('category', editableItem.category);
    formData.append('pureVeg', editableItem.pureVeg ? "1" : "0");
    formData.append('recommend', editableItem.recommend ? "true" : "false");
    formData.append('warrantyInfo', editableItem.warrantyInfo || '');
    formData.append('returnPolicy', editableItem.returnPolicy || '');
    formData.append('manufacturer', editableItem.manufacturer || '');
    formData.append('modelNumber', editableItem.modelNumber || '');
    formData.append('tags', editableItem.tags || '');
    formData.append('labels', editableItem.labels || '');
    formData.append('countryOfOrigin', editableItem.countryOfOrigin || '');
    formData.append('description', editableItem.description || '');
    formData.append('purchaseDate', editableItem.purchaseDate);
    formData.append('expiryDate', editableItem.expiryDate);

    // Handle main image
    if (editableItem.image instanceof File) {
      formData.append('image', editableItem.image);
    } else if (editableItem.image) {
      // If it's a string (existing image URL), we need to handle it differently
      // You might want to skip it or send as a string parameter
      // formData.append('imageUrl', editableItem.image);
    }

    // Handle additional images
    if (editableItem.additionalImages && editableItem.additionalImages.length > 0) {
      editableItem.additionalImages.forEach((img, index) => {
        if (img instanceof File) {
          formData.append('additionalImages', img);
        }
        // For existing images, you might need to send them as URLs in another field
      });
    }

    const variants = weights.map(v => ({
      ...v,
      isReturnable: v.returnable // Map returnable to isReturnable
    }));

    // Append product variants as JSON string
    formData.append('productVarients', JSON.stringify(variants));

    try {
      setLoading(true);
      console.log('Form Data:', JSON.stringify(formData, null, 2));
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      const response = await axiosAPIinstance.patch(
        `/product/updateProductDetails/${item.productId}`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          secure: true
        }
      );

      setResponse(response.data);
      setOpenModal(true);
      setLoading(false);
      window.alert(response.data.message || 'Product updated successfully');

      // Call onSave callback if update was successful
      if (response.data.success) {
        onSave(response.data);
        onClose();
      }
    } catch (error) {
      console.error('Error updating item:', error);
      const errorMessage = error.response?.data?.message || 'Error updating item. Please try again.';
      setResponse({
        success: false,
        message: errorMessage
      });
      window.alert(errorMessage);
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    if (response.success) {
      onSave();
      onClose();
    }
  };

  useEffect(() => {
    axiosAPIinstance.get('/categories')
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }, []);

  return (
    <>
      <Dialog
        open={Boolean(item)}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          {isEditMode ? 'Edit Product Details' : 'View Product Details'}
        </DialogTitle>
        <DialogContent dividers>
          <form onSubmit={handleSave}>
            <Grid container spacing={2} margin={1} width={'95%'}>
              {/* Product Information Fields */}
              <Grid item xs={12} sm={6}>
                <TextField
                  name="productName"
                  label="Product Name"
                  fullWidth
                  required
                  value={editableItem.productName}
                  onChange={handleInputChange}
                  disabled={!isEditMode}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="hsCodeBarCode"
                  label="HSCode/Barcode"
                  fullWidth
                  value={editableItem.hsCodeBarCode}
                  onChange={handleInputChange}
                  disabled={!isEditMode}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="brand"
                  label="Brand"
                  fullWidth
                  required
                  value={editableItem.brand}
                  onChange={handleInputChange}
                  disabled={!isEditMode}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel>Category</InputLabel>
                  <Select
                    name="category"
                    value={editableItem.category}
                    onChange={handleInputChange}
                    label="Category"
                    disabled={!isEditMode}
                  >
                    {categories.map((category) => (
                      <MenuItem key={category.id} value={category.name}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Is PureVeg</InputLabel>
                  <Select
                    name="pureVeg"
                    value={editableItem.pureVeg ?? 0}
                    onChange={handleInputChange}
                    label="Is PureVeg"
                    disabled={!isEditMode}
                  >
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="recommend"
                      checked={editableItem.recommend ?? false}
                      onChange={handleInputChange}
                      color="primary"
                      disabled={!isEditMode}
                    />
                  }
                  label="Recommend"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="returnPolicy"
                  label="Return Policy"
                  fullWidth
                  value={editableItem.returnPolicy}
                  onChange={handleInputChange}
                  disabled={!isEditMode}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="tags"
                  label="Tags"
                  fullWidth
                  value={editableItem.tags}
                  onChange={handleInputChange}
                  disabled={!isEditMode}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="labels"
                  label="Labels"
                  fullWidth
                  value={editableItem.labels}
                  onChange={handleInputChange}
                  disabled={!isEditMode}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Purchase Date"
                    value={editableItem.purchaseDate}
                    required
                    disabled={!isEditMode}
                    onChange={(date) => handleDateChange('purchaseDate', date)}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Expiry Date"
                    value={editableItem.expiryDate}
                    required
                    disabled={!isEditMode}
                    onChange={(date) => handleDateChange('expiryDate', date)}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              {/* Additional product fields... */}

              {/* Weight Variants Section */}
              {weights.map((weight, index) => (
                <Grid container spacing={2} margin={1} padding={1} key={index}
                  style={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>

                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth required>
                      <InputLabel>Weight</InputLabel>
                      <Select
                        value={weight.weight}
                        disabled={!isEditMode}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === 'Enter Manually') {
                            setSelectedWeightIndex(index);
                            setOpenWeightModal(true);
                          } else {
                            handleWeightChange(index, 'weight', value);
                          }
                        }}
                        label="Weight"
                      >
                        {dynamicWeightOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            <ListItemText primary={option} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="MRP"
                      type="number"
                      fullWidth
                      required
                      disabled={!isEditMode}
                      value={weight.mrp}
                      onChange={(e) => handleWeightChange(index, 'mrp', e.target.value)}
                      onBlur={(e) => handleWeightChange(index, 'mrp', formatFloat(e.target.value))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="SP_With_GST"
                      type="number"
                      fullWidth
                      required
                      disabled={!isEditMode}
                      value={weight.sellingPriceWithGST}
                      onChange={(e) => handleWeightChange(index, 'sellingPriceWithGST', e.target.value)}
                      onBlur={(e) => handleWeightChange(index, 'sellingPriceWithGST', formatFloat(e.target.value))}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="GST %"
                      type="number"
                      fullWidth
                      required
                      disabled={!isEditMode}
                      value={weight.gstPercent}
                      onChange={(e) => handleWeightChange(index, 'gstPercent', e.target.value)}
                      onBlur={(e) => handleWeightChange(index, 'gstPercent', formatFloat(e.target.value))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="Discount %"
                      type="number"
                      fullWidth
                      required
                      disabled
                      value={weight.discountPercent}
                      onChange={(e) => handleWeightChange(index, 'discountPercent', e.target.value)}
                      onBlur={(e) => handleWeightChange(index, 'discountPercent', formatFloat(e.target.value))}
                    />
                  </Grid>


                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="Selling Price"
                      type="number"
                      fullWidth
                      disabled
                      value={weight.sellingPrice}
                    />
                  </Grid>









                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="GST Price/Value"
                      type="number"
                      fullWidth
                      disabled
                      value={weight.gstPrice}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="MinPurchaseQty"
                      type="number"
                      fullWidth
                      required
                      disabled={!isEditMode}
                      value={weight.minPurchaseQty}
                      onChange={(e) => handleWeightChange(index, 'minPurchaseQty', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="MaxPurchaseQty"
                      type="number"
                      fullWidth
                      required
                      disabled={!isEditMode}
                      value={weight.maxPurchaseQty}
                      onChange={(e) => handleWeightChange(index, 'maxPurchaseQty', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="Available Stock"
                      type="number"
                      fullWidth
                      required
                      disabled={!isEditMode}
                      value={weight.availableStock}
                      onChange={(e) => handleWeightChange(index, 'availableStock', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth required disabled={!isEditMode}>
                      <InputLabel id="availability-status-label">Availability Status</InputLabel>
                      <Select
                        value={weight.availabilityStatus}
                        onChange={(e) => handleWeightChange(index, 'availabilityStatus', e.target.value)}
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth required disabled={!isEditMode}>
                      <InputLabel id="returnable-status-label">Is Returnable</InputLabel>
                      <Select
                        value={weight.returnable}
                        onChange={(e) => handleWeightChange(index, 'returnable', e.target.value)}
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <TextField
                      label="SKU Barcode"
                      fullWidth
                      disabled={!isEditMode}
                      value={weight.skuBarCode}
                      onChange={(e) => handleWeightChange(index, 'skuBarCode', e.target.value)}
                    />
                  </Grid>

                  {showCalculateButton && isEditMode && (
                    <Grid item xs={12} sm={2}>
                      <Button
                        variant="contained"
                        onClick={() => handleCalculate(index)}
                        fullWidth
                      >
                        Calculate
                      </Button>
                    </Grid>
                  )}










                  {/* More variant fields... */}

                  <Grid item xs={12} sm={1}>
                    <IconButton
                      disabled={!isEditMode || weights.length <= 1}
                      onClick={() => removeWeightField(index)}
                      color="error"
                    >
                      <RemoveCircleOutline />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}

              {isEditMode && (
                <Grid item xs={12} sm={3}>
                  <Button onClick={addWeightField} variant="outlined" fullWidth>
                    Add Variant
                  </Button>
                </Grid>
              )}


              {imagePreview && (
                <Grid item xs={12}>
                  <img
                    src={typeof editableItem.image === 'string' ? editableItem.image : imagePreview}
                    alt="Product Preview"
                    style={{
                      width: '250px',
                      maxHeight: '250px',
                      objectFit: 'cover',
                      borderRadius: '8px'
                    }}
                  />
                </Grid>
              )}
              {/* Image Upload Sections */}
              <Grid item xs={12} sm={6}>
                <Button
                  variant="contained"
                  component="label"
                  disabled={!isEditMode}
                  fullWidth
                  style={{ marginTop: '16px' }}
                >
                  {editableItem.image ? 'Change Image' : 'Upload Image'}
                  <input
                    type="file"
                    hidden
                    name="image"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </Button>
              </Grid>




              <Grid item xs={12} sm={6}>
                <Button
                  variant="contained"
                  component="label"
                  disabled={!isEditMode}
                  fullWidth
                  style={{
                    marginTop: '16px',
                    backgroundColor: imgError ? '#ffebee' : '', // Light red background if error
                    color: imgError ? '#d32f2f' : '' // Dark red text if error
                  }}
                >
                  {editableItem.additionalImages?.length > 0 ? 'Add More Images' : 'Upload Additional Images'}
                  <input
                    type="file"
                    hidden
                    multiple
                    name="additionalImages"
                    onChange={handleAdditionalFilesChange}
                    accept="image/*"
                  />
                </Button>
              </Grid>

              {additionalImagePreviews.length > 0 && (
                <Grid item xs={12}>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px',
                    marginTop: '8px'
                  }}>
                    {additionalImagePreviews.map((image, index) => {
                      // Clean the image URL before displaying
                      const cleanImageUrl = typeof image === 'string'
                        ? image.replace(/^"+|"+$/g, '').replace(/\\/g, '')
                        : URL.createObjectURL(image);

                      return (
                        <div key={index} style={{ position: 'relative' }}>
                          <img
                            src={cleanImageUrl}
                            alt={`Additional Preview ${index + 1}`}
                            style={{
                              width: '100px',
                              height: '100px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                              border: '1px solid #e0e0e0'
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = '/placeholder-image.jpg';
                            }}
                          />
                          {isEditMode && (
                            <IconButton
                              size="small"
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                color: 'white'
                              }}
                              onClick={() => removeAdditionalImage(index)}
                            >
                              X
                            </IconButton>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Grid>
              )}

              {/* Description Field */}
              <Grid item xs={12}>
                <TextField
                  name="description"
                  label="Description"
                  multiline
                  rows={4}
                  fullWidth
                  disabled={!isEditMode}
                  value={editableItem.description}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
          {isEditMode && (
            <Button
              onClick={handleSave}
              color="primary"
              variant="contained"
              disabled={loading}
            >
              {loading ? <UnversalSpinner size={24} /> : 'Save Changes'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Response Modal - Enhanced */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{
          backgroundColor: response.success ? '#4caf50' : '#f44336',
          color: 'white'
        }}>
          {response.success ? 'Success' : 'Error'}
        </DialogTitle>
        <DialogContent sx={{ padding: '20px' }}>
          <Typography variant="body1">
            {response.message ||
              (response.success
                ? 'Product updated successfully'
                : 'Failed to update product')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseModal}
            color="primary"
            variant="contained"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Manual Weight Entry Modal */}
      <Dialog open={openWeightModal} onClose={() => setOpenWeightModal(false)}>
        <DialogTitle>Enter Weight Manually</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Weight"
            type="text"
            fullWidth
            variant="standard"
            value={manualWeightValue}
            onChange={(e) => setManualWeightValue(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleManualWeightSubmit()}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenWeightModal(false)}>Cancel</Button>
          <Button onClick={handleManualWeightSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewUpdateItemDetails;